import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveHeadsStepMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveHeadsStep = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveHeadsStepMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveHeadsStep
      ? parseLegalClient(data.legalClientSaveHeadsStep)
      : undefined,
    loading,
    error,
    saveHeadsStep: useCallback(
      async (id: string) => {
        const res = await handle({
          variables: {
            id,
          },
        });
        return res.data?.legalClientSaveHeadsStep
          ? parseLegalClient(res.data.legalClientSaveHeadsStep)
          : undefined;
      },
      [handle]
    ),
  };
};
